'use client';
import { useSearchParams, usePathname } from 'next/navigation';

const getShopUrlPrepend = () => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  if (pathname.includes('shops')) {
    if (searchParams.get('shopname')) {
      return `/shops/${searchParams.get('shopname')}`;
    } else {
      return '';
    }
  } else {
    return '';
  }
};

export default getShopUrlPrepend;
